require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-take-home-projects-build-a-roguelike-dungeon-crawler-game.json") })
        }
      }, "path---coding-interview-prep-take-home-projects-build-a-roguelike-dungeon-crawler-game");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-take-home-projects-build-a-roguelike-dungeon-crawler-game!./.cache/json/coding-interview-prep-take-home-projects-build-a-roguelike-dungeon-crawler-game.json
// module id = 1923
// module chunks = 231608221292675